import { jsx } from "react/jsx-runtime";
import { TextInputFieldWUT } from "../../../ui/text-input-field/text-input-field-wut.js";
import { FIELD_TYPES } from "../../../constants/field-types.js";
const ContactsEmailWUT = (props) => {
  const fieldType = FIELD_TYPES.CONTACTS_EMAIL;
  return /* @__PURE__ */ jsx(TextInputFieldWUT, { ...props, type: "email", fieldType });
};
export {
  ContactsEmailWUT
};
//# sourceMappingURL=contacts-email-wut.js.map
